// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3sOHf","noInteraction":"EventWrapper_noInteraction__pe1cV","pointerPassthrough":"EventWrapper_pointerPassthrough__wLB1S"};